import { menuselect_solution } from "@/constant/menuselect";

let str = "业务概述";
export const config = {
  title: "医疗集团管理",
  headerInfo:
    "医疗集团高效管理的核心在于搭建统一的管控平台，汇集各级运营单位人、财、物和风险控制的过程管理和信息流，以推进集团管控目标的落地。实现医院间专业化布局与协同发展，高效使用医疗资源，提高临床服务能力与质量。",
  headerImg: require("@/assets/images/odr_system/medical_group_manager.png"),
  activeSubTitle: str,
  navList: [
    {
      name: "医疗集团管理",
      children:menuselect_solution(),
    },
    {
      name: "业务概述",
      desc: "",
      tabList: [{}],
      [str]: [
        {
          desc: "医疗集团高效管理的核心在于搭建统一的管控平台，汇集各级运营单位人、财、物和风险控制的过程管理和信息流，以推进集团管控目标的落地。实现医院间专业化布局与协同发展，高效使用医疗资源，提高临床服务能力与质量。",
          img: require("@/assets/images/odr_system/img_project_content1.svg"),
        },
        {
          title: "集团化管控模式",
          img: require("@/assets/images/odr_system/img_project_content2.svg"),
        },
        {
          title: "医疗集团建设目的",
          img: require("@/assets/images/odr_system/img_project_content3.svg"),
        },
        {
          title: "管理价值",
          desc: "敬在集团化管控方案，满足包括集团运营决策层、管理层、执行层等不同层面的角色所面临的管理需求及关注点，进而确保管理有效落地，提升整体运营。",
          img: require("@/assets/images/odr_system/img_project_content4.svg"),
        },
      ],
    },
    {
      name: "业务方案",
      desc: "",
      tabList: [{}],
      [str]: [
        {
          title: "主数据管理",
          desc: "基于业务形态的主数据标准化体系，实现主数据管理从标准化制定到业务规范执行落地。",
          img: require("@/assets/images/odr_system/Group 788one2.svg"),
        },
        {
          title: "整合供应链、集团化物资管理新模式",
          desc: "建立供应链垂直一体化管理体系，为医院集团的设立提供专业支持，确保一级单位更专注的提供更专业的医疗服务。",
          img: require("@/assets/images/odr_system/Frame 818one2.svg"),
        },
        {
          title: "自上而下、全生命周期的资产管理",
          desc: "业财联动、管理与使用并重，资产全程追溯分析。",
          img: require("@/assets/images/odr_system/Group 285one2.svg"),
        },
        {
          title: "财务共享中心管理模式",
          desc: "通过专业化的服务，提高效率，降低交易处理业务所占用的时间和精力，并将其转移到高附加值的决策支持型业务上去，实现财务管理从核算型向价值型转变，实现财务管理的精益化、高效化、专业化，即建立财务共享中心管理模式。",
          img: require("@/assets/images/odr_system/Group 305one2.svg"),
        },
        {
          title: "全面预算管理",
          desc: "通过建立全面预算管控平台，优化资源配置，计划与执行协同共享，进行事前与事中控制，事后分析。同时，预算系统与其他业务系统进行衔接，例如与合同管理、网报管理、资金管理以及财务管理系统无缝集成，以全面预算为抓手，控制合同签订，以合同执行反馈预算执行情况，以合同和资金计划控制资金支付，做到无预算不合同、无合同不付款，控制医疗集团管理风险。",
          img: require("@/assets/images/odr_system/Group 890one2.svg"),
        },
        {
          title: "绩效管理",
          desc: "绩效分配遵循量效结合的总体思想，现多劳多得效率优先的原则，鼓励节约，考核成本。引入RBRVS、DRGs等科学的绩效核算标准，全员参与进行绩效标准的讨论、确定。定能够真正体现不司职系工作人员工作特点、劳动强度、风险和技术含量的工作量绩效点值。",
          img: require("@/assets/images/odr_system/Frame 1143one2.svg"),
        },
        {
          title: "全成本管理",
          desc: "层层推进，推动医院全成本管理，通过实现科室成本核算、主诊组成本统计为全成本核算建立基础数据支持。构建集团统一的成本管理办法、统一的成本核算指标，实现集团内部横向对比分析。",
          img: require("@/assets/images/odr_system/Group 892one2.svg"),
        },
        {
          title: "建立集团“大”人力资源平台",
          desc: "集团人力资源管理是搭建集团组织机构体系，实现医疗集团内人员全生命周期管理，围绕人员的变动，入职，调动，晋升，培训，辞职，退休等一系列的人事活动来进行数据记录，形成人员全生命周期记录，构建人员在集团服务期间的活动地图，同时也是集团人力资源业务协同平台。",
          img: require("@/assets/images/odr_system/Group 363one2.svg"),
        },
      ],
    },
  ],
};
